import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IUserProfile} from 'app/types/Shared';
import {RootState} from '..';

// Custom token interface compatible with MSAL
export interface IAccessToken {
  accessToken: string;
  idToken?: string;
  expiresAt: number;
}

export interface IAuthError {
  message: string;
}

export interface IAuthState {
  isAuthenticated: boolean;
  userProfile?: IUserProfile;
  isLoading: boolean;
  error: IAuthError;
  token?: IAccessToken;
}

export const initialState: IAuthState = {
  isAuthenticated: false,
  userProfile: undefined,
  isLoading: false,
  error: {message: 'An Authentication Error occurred'},
  token: undefined,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading: (state, {payload}: PayloadAction<boolean>) => {
      state.isLoading = payload;
    },
    setAuthSuccess: (state, {payload}: PayloadAction<IUserProfile>) => {
      state.userProfile = payload;
      state.isAuthenticated = true;
    },
    setLogOut: (state) => {
      state.isAuthenticated = false;
      state.userProfile = undefined;
      state.token = undefined;
    },
    setInactiveLogout: (state) => {
      state.isAuthenticated = false;
      state.userProfile = undefined;
      state.token = undefined;
    },
    setAuthFailed: (state, {payload}: PayloadAction<IAuthError>) => {
      state.error = payload;
      state.isAuthenticated = false;
    },
    setAuthToken: (state, {payload}: PayloadAction<IAccessToken>) => {
      state.token = payload;
      //initalize store
      // get opModels,Milestones,user roles/pins, select OPModel
    },
  },
});

export const {setAuthSuccess, setLogOut, setLoading, setAuthFailed, setAuthToken, setInactiveLogout} =
  authSlice.actions;

export const selectUserProfile = (state: RootState) => state.auth;
export default authSlice.reducer;
